import gql from 'graphql-tag';

export const RESEARCH_PAPER_QUERY = gql`
    query getResearchPaper($id: ID!) {
        researchPaper(id:$id) {
            id
            createdAt
            createdBy { firstName lastName }
            updatedAt
            updatedBy { firstName lastName}
            nickname
            title
            abstract
            description
            assetType
            publicationDate
            url
            links
            trl
            notes
            assetSources {edges {node {externalSourceId source {id name}}}}
            applicationTypes {edges {node {id name}}}
            tags
            authors {edges {node {id nickname partyType}}}
            journal
            doiId
            materials {edges {node {id name acronym}}}
            assetFiles {edges {node {id file {name url} deleted}}} 
            processingTechniques{ edges {node {id name}}}
            standards {edges {node {id code title}}}
            assetStatus {id name}
            statusReason
            assetLinkedPrograms {
                edges {
                    node {
                        id
                        program {id name}
                        linkType {id name}
                        linkStatus {id name colorCode}
                        statusReason
                    }
                }
            }
            assetPrice {id price quantity unitType{id name} unitTypeSize notes}
        }
    }`
